import { getPublicProductBundlesWithQuantities } from 'pricing-pages-api/bundles/ProductBundlesWithQuantitiesApi';
import { productConfigurationsToBundleProducts } from 'pricing-pages-lib/utils/planBuilderUtils';
import debounce from 'react-utils/debounce';
import { fetchBundlesApiCompleted, fetchBundlesApiFailed, fetchBundlesApiStarted } from '../actions/PlanBuilderActions';
import { PLAN_BUILDER_INITIALIZATION_COMPLETE, PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED } from '../actions/constants/ActionTypes';
import { planBuilderCountryCodeSelector, planBuilderProductConfigurationsSelector } from '../selectors/PlanBuilderSelectors';
import { productDataSelector } from '../selectors/SelectorUtils';
import { Metrics } from '../utils/metrics';
const processBundlesApi = async store => {
  const state = store.getState();
  const productConfigurations = planBuilderProductConfigurationsSelector(state);
  const countryCode = planBuilderCountryCodeSelector(state);
  const productData = productDataSelector(state);
  const bundleProducts = productConfigurationsToBundleProducts({
    productData
  }, {
    productConfigurations
  });
  try {
    const newBundleProducts = await getPublicProductBundlesWithQuantities({
      countryCode,
      products: bundleProducts
    });
    store.dispatch(fetchBundlesApiCompleted({
      productData,
      bundleProducts: newBundleProducts
    }));
    Metrics.counter('fetch-bundles-api-succeeded', {
      countryCode: countryCode.toString()
    }).increment();
  } catch (_unused) {
    store.dispatch(fetchBundlesApiFailed());
    Metrics.counter('fetch-bundles-api-failed', {
      countryCode: countryCode.toString(),
      bundleProducts: JSON.stringify(bundleProducts)
    }).increment();
  }
};
const debouncedProcessBundlesApi = debounce(processBundlesApi, 300);

/**
 * Calls MonBE's bundles API after certain actions have updated productConfigurations
 * the bundles API is responsible for turning, e.g. 5 Starter hubs -> 1 Suite Starter bundle
 *
 * It's not necessary to call the bundles API on _every_ update to productConfigurations,
 * only on page load and when a new product gets added or a product level gets updated
 */
export const bundlesApiMiddleware = store => next => action => {
  if (action.type === PLAN_BUILDER_INITIALIZATION_COMPLETE || action.type === PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED) {
    // Commit the previous action's payload to state so we can access
    // the updated productConfigurations below
    next(action);

    // Apply the loading state
    store.dispatch(fetchBundlesApiStarted());

    // Use debounced processing to prevent excessive API calls
    debouncedProcessBundlesApi(store);
    return;
  }
  return next(action);
};